<template>
  <div class="input-ripple">
    <!-- Input -->
    <div class="input-ripple__input">
      <input
        :id="id"
        :value="value"
        :type="type"
        :name="id"
        :readonly="disabled"
        :placeholder="$t(placeholder)"
        autocomplete="off"
        required
        @keyup.enter="clickSubmit()"
        @keyup.esc="clickClose()"
        @input="updateValue($event.target.value)"
        @focus="expand = true"
        @blur="expand = false"
      >

      <label
        :for="id"
        @click="clickSubmit()"
      >
        <slot name="icon" />
      </label>
    </div>

    <input-checkbox-view
      :class="{'hasError': !marketingConcent && hasMissingConcent, 'expanded': expand}"
      :model="marketingConcent"
      type="checkbox"
      label="marketing_concent"
      @updateValue="updateMarketingConcent"
    />

    <!-- Ripple -->
    <ripple-view :expand="expand" />
  </div>
</template>

<script>
import uid from '@/mixins/uid';

export default {
  name: 'InputRipple',

  components: {
    RippleView: () => import('@/components/ripple/ripple-view'),
    InputCheckboxView: () => import('@/components/input/input-checkbox-view')
  },

  mixins: [uid],

  props: {
    // v-model accepts a value prop
    value: {
      type: String,
      default: ''
    },

    type: {
      type: String,
      default: 'text'
    },

    rgpdConcent: {
      type: Boolean,
      default: false
    },

    marketingConcent: {
      type: Boolean,
      default: false
    },

    hasMissingConcent: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    placeholder: {
      type: String,
      default: ''
    },

    variant: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      expand: false
    };
  },

  methods: {
    clickSubmit() {
      this.expand = false;

      this.$emit('click-submit');
    },

    clickClose() {
      this.expand = false;

      document.getElementById(this.id).blur();
    },

    updateValue(value) {
      // Emit the number value through the input event
      this.$emit('input', value);
    },

    updateMarketingConcent(value) {
      this.$emit('updateMarketingConcent', value);
    }
  }
};
</script>

<style lang="scss" src="@/assets/components/input/input-ripple-view.scss"></style>



// WEBPACK FOOTER //
// input-ripple-view.vue